import signals from '../store/signals'
import store from '../store/store'

class ScrollShowController {
  constructor (props) {
    this.els = []

    this.checkSectionStartScrollStep1 = this.checkSectionStartScrollStep1.bind(this)
    this.initParams = this.initParams.bind(this)
    this.resetElements = this.resetElements.bind(this)
    this.securityCheck = this.securityCheck.bind(this)

    this.initParams()
    this.bind()
  }

  initParams () {
    setTimeout(() => {
      this.els = [...document.querySelectorAll('.js-scroll-show')]
      this.securityCheck()
    }, 700)
  }

  bind () {
    signals.startingSection.listen(this.checkSectionStartScrollStep1)
    signals.resetScrollama.listen(this.resetElements)
  }

  unbind () {
    signals.startingSection.unlisten(this.checkSectionStartScrollStep1)
    signals.resetScrollama.unlisten(this.resetElements)
  }

  checkSectionStartScrollStep1 (response) {
    this.els.forEach((el) => {
      const scrollStepElement = el.closest('.scroll-step')
      if (!scrollStepElement) return
      const scrollIndex = scrollStepElement.dataset.scrollamaIndex
      if (response.index == scrollIndex) this.fire(el)
    })
  }

  securityCheck () {
    this.els.forEach((el) => {
      const offsets = this.getOffsets(el)
      if (offsets.y < store.resize.get().height) {
        this.fire(el)
      }
    })
  }

  getOffsets(element) {
    var xPosition = 0;
    var yPosition = 0;

    while(element) {
        xPosition += (element.offsetLeft - element.scrollLeft + element.clientLeft);
        yPosition += (element.offsetTop - element.scrollTop + element.clientTop);
        element = element.offsetParent;
    }

    return { x: xPosition, y: yPosition };
  }

  resetElements () {
    this.initParams()
  }

  fire (el) {
    el.classList.add('visible')
  }
}

export default new ScrollShowController()
